import { createAction, createAsyncAction } from 'typesafe-actions';

import { AlertConfig } from '../types';
import { FetchSimulationCubeSuccessPayload, SimulationCubeFilters } from './types';

export const setSelectedDate       = createAction('flCashConsumption/setSelectedDate')<string>();
export const setAlertConfig        = createAction('flCashConsumption/setAlertConfig')<AlertConfig>();
export const setSimulationProgress = createAction('flCashConsumption/setSimulationProgress')<number | null>();

export const fetchSimulationCube = createAsyncAction(
  'flCashConsumption/fetchSimulationCube/request',
  'flCashConsumption/fetchSimulationCube/success',
  'flCashConsumption/fetchSimulationCube/failure',
)<SimulationCubeFilters | undefined, FetchSimulationCubeSuccessPayload, undefined>();
